import React from "react";
import { useI18n } from "../i18n";

export default function LanguageToggle() {
  const { lang, setLang } = useI18n();
  return (
    <div className="flex items-center rounded-full border border-amber-500/30 bg-[#112240] p-0.5 text-xs font-semibold" data-testid="lang-toggle">
      <button
        data-testid="lang-toggle-es"
        onClick={() => setLang("es")}
        className={`px-3 py-1 rounded-full transition-all ${lang === "es" ? "bg-amber-500 text-slate-950" : "text-slate-300 hover:text-amber-300"}`}
      >ES</button>
      <button
        data-testid="lang-toggle-en"
        onClick={() => setLang("en")}
        className={`px-3 py-1 rounded-full transition-all ${lang === "en" ? "bg-amber-500 text-slate-950" : "text-slate-300 hover:text-amber-300"}`}
      >EN</button>
    </div>
  );
}
